<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <label>
          Лицо:
          <select v-model="newPass.FACE" @change="updateFaces">
            <option v-for="(face, key) in faces" :key="key" :value="face.USER_ID" >{{face.USER_NAME}}</option>
          </select>
        </label>
      </div>
      <div class="form-field">
        <label>
          Машина:
          <select v-model="newPass.AUTO"  @change="updateKppType">
            <option v-for="(vehicle, key) in vehicles" :key="key" :value="vehicle.ID" >{{vehicle.NUMBER}}</option>
          </select>
        </label>
      </div>
      <div class="form-field" v-show="kppType.METHOD === 'RFID'">
        <label for="rfid-input">RFID:</label>
        <input id="rfid-input" v-model="newPass.rfid" type="text" />
      </div>
      <div class="form-field" v-if="kppType.TIME === 'Временный'">
        <label for="date-from-input">Начало периода:</label>
        <input id="date-from-input" type="date" v-model="newPass.dateFrom" />
        <label for="date-to-input">Конец периода:</label>
        <input id="date-to-input" type="date" v-model="newPass.dateTo" />
      </div>
      <div class="form-field">
        <img v-show="waite" src="@/assets/wait.gif" class="waite" alt="" />
        <button v-show="!waite" @click="sendAutoData">Отправить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "AddPass",
  props: ["plot"],
  data() {
    return {
      url: config.backend_url,
      units: [],
      groups: [],
      newPass: {},
      faces: {},
      currentFace: {},
      vehicles: [],
      vehicle: {},
      kppType: {},
      idPlot: this.plot,
      info: false,
      waite1: false,
      waite: false
    };
  },
  computed: {
    showUnit: function() {
      let self = this;
      return this.units.filter(function(unit) {
        return !self.unitHaveChildren.includes(unit.ID);
      });
    }
  },
  methods: {
    sendAutoData: function() {
      let self = this;
      self.waite = true;
      let dataSent = self.newPass;
      dataSent.currentFace = self.currentFace;
      dataSent.vehicle = self.vehicle;
      dataSent.kppType = self.kppType;
      dataSent.numberPlant = self.plot;
      let data = {
        url: self.url + "parsec/add-rfid/",
        data: dataSent,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        console.log(data);
        if (data.error) {
          self.info = data.error;
        } else {
          self.info = data.parsecPersonID
            ? "ID пользователя: " + data.parsecPersonID
            : "Ошибка добавления пропуска в Parsec";
        }
        self.waite = false;
      });
    },
    updateFaces: function (){
      this.currentFace = this.faces[this.newPass.FACE];
      this.vehicles = this.currentFace.VEHICLES;
    },
    updateKppType: function (){
      this.vehicle = this.vehicles[this.newPass.AUTO];
      this.kppType = this.kppTypes[this.vehicle.KPP_TYPE];
    },
    getPlotKppTypes: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-kpp-types/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.kppTypes = data;
          }
        });
    },
    getPlotFaces: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-faces/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.faces = data;
        });
    }
  },
  created() {
    this.getPlotFaces();
    this.getPlotKppTypes();
  }
};
</script>
